import React, { Component } from "react";
import { func, bool, shape } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { Box, Hint } from "@ui-kit/components/index.es";

import MainContainer from "pages/_components/MainContainer";
import PageLoading from "pages/_components/PageLoading";
import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";

import { actions as paymentsAFIPActions, selectors as paymentsAFIPSelectors } from "reducers/paymentsAFIP";
import { actions as servicePaymentsActions } from "reducers/servicePayments";
import { selectors as sessionSelectors } from "reducers/session";

import PaymentAFIPDetailContent from "pages/servicePayments/_components/PaymentAFIPDetailContent";

import * as i18n from "util/i18n";
import { getServicePaymentsPath, isUxPaymentsServicesImprovementsEnabled } from "util/servicePaymentsRoutes";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import { resizableRoute } from "pages/_components/Resizable";
import ContextMenu from "pages/_components/ContextMenu";
import InfoTag from "pages/_components/InfoTag";

class MultipleAFIPDetail extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        paymentAFIP: shape({}).isRequired,
        fetching: bool.isRequired,
        activeEnvironment: shape({}).isRequired,
        isReturnFromDetail: bool.isRequired,
    };

    componentDidMount() {
        const { paymentAFIP } = this.props;
        this.syncEmbeddedV3ShellLayout();
        if (!paymentAFIP) {
            this.handleGoBack();
        }
    }

    componentDidUpdate(prevProps) {
        const { isDesktop, paymentAFIP } = this.props;
        if (
            isUxDashboardImprovementsEnabled() &&
            (prevProps.isDesktop !== isDesktop || prevProps.paymentAFIP !== paymentAFIP)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        if (isUxDashboardImprovementsEnabled()) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, isDesktop, paymentAFIP } = this.props;
        const uxDashboardImprovements = isUxDashboardImprovementsEnabled();
        const numberVEP = paymentAFIP ? Number(paymentAFIP.numberVEP) : undefined;
        const headerTitle = paymentAFIP != null ? i18n.get("paymentsAFIP.details.title", null, { numberVEP }) : "";

        let rightContentMobile = null;
        if (!isDesktop && paymentAFIP) {
            const { type, token } = paymentAFIP;
            if (type === "PE" && token) {
                rightContentMobile = this.rightContent();
            }
        }

        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell: uxDashboardImprovements,
            isDesktop,
            scopes: ["paymentAFIP"],
            headerTitle,
            goBackPath: getServicePaymentsPath(),
            rightContentMobile,
        });
    };

    handleGoBack = () => {
        const { dispatch, isReturnFromDetail } = this.props;
        dispatch(servicePaymentsActions.setPaymentSelected());
        dispatch(paymentsAFIPActions.setIsBackFromOtherPage(isReturnFromDetail));
    };

    centerContentMobile = () => {
        const { isDesktop, paymentAFIP } = this.props;

        const numberVEP = paymentAFIP ? Number(paymentAFIP.numberVEP) : undefined;

        if (!isDesktop) {
            return (
                <div className="title-account-header-multiline-background-blue">
                    <h1 style={{ margin: "-0.5rem 2rem" }}>
                        {i18n.get("paymentsAFIP.details.title", null, { numberVEP })}
                    </h1>
                </div>
            );
        }

        return (
            <div className="view-title d-flex align-items-center">
                <h1>{i18n.get("paymentsAFIP.details.title", null, { numberVEP })}</h1>
                {paymentAFIP.isPending && (
                    <div className="ml-3">
                        {isUxPaymentsServicesImprovementsEnabled() ? (
                            <Hint colorText="dark" colorIcon="dark" text={i18n.get("pay.paymentAFIP.signPending")} />
                        ) : (
                            <InfoTag
                                type="info"
                                message={i18n.get(`payments.serviceAFIP.detail.status.PENDING`)}
                                tagBackground="#FFE5B6"
                                tagClass="max-width-mincontent px-2 text-nowrap"
                                moreStyles={{
                                    color: "black",
                                }}
                            />
                        )}
                    </div>
                )}
            </div>
        );
    };

    handlePay = () => {
        const { dispatch, paymentAFIP } = this.props;

        dispatch(paymentsAFIPActions.cleanHandleBackFromTicket());
        // TODO: Revisar que llama a la vista de nuevo pago no se puede sacar solo
        dispatch(paymentsAFIPActions.payPaymentAFIPPre(paymentAFIP, true));
    };

    handleDelete = () => {
        const { dispatch, paymentAFIP } = this.props;

        dispatch(paymentsAFIPActions.deletePaymentAFIPPre(paymentAFIP, true));
    };

    rightContent = () => {
        const { activeEnvironment, paymentAFIP, isDesktop } = this.props;
        const { type, token } = paymentAFIP;

        if (isDesktop && token) {
            return (
                <Box flex gap={16}>
                    {type === "PE" && activeEnvironment.permissions.accounts && !paymentAFIP.isPending && (
                        <Button
                            block
                            label="payments.afip.list.actions.pay"
                            bsStyle="primary"
                            className="cmf-button-width"
                            onClick={this.handlePay}
                        />
                    )}
                    {type === "PE" && (
                        <Button
                            block
                            label="payments.afip.list.actions.delete"
                            className="btn-outline cmf-button-width"
                            onClick={this.handleDelete}
                        />
                    )}
                </Box>
            );
        }
        return (
            <>
                {type === "PE" && token && paymentAFIP.isPending && (
                    <ContextMenu
                        styleContext={{ justifyContent: "flex-end" }}
                        color="white"
                        items={[
                            {
                                label: "payments.afip.list.actions.delete",
                                onClick: () => this.handleDelete(),
                                icon: "Trash",
                            },
                        ]}
                    />
                )}
                {type === "PE" && token && !paymentAFIP.isPending && (
                    <ContextMenu
                        styleContext={{ justifyContent: "flex-end" }}
                        color="white"
                        items={[
                            {
                                label: "payments.afip.list.actions.pay",
                                onClick: () => this.handlePay(),
                                icon: "MoneyCircle",
                            },
                            {
                                label: "payments.afip.list.actions.delete",
                                onClick: () => this.handleDelete(),
                                icon: "Trash",
                            },
                        ]}
                    />
                )}
            </>
        );
    };

    render() {
        const { isDesktop, fetching, paymentAFIP } = this.props;
        const uxDashboardImprovements = isUxDashboardImprovementsEnabled();

        const showLegacyHead = !uxDashboardImprovements || isDesktop;

        return !paymentAFIP ? (
            <></>
        ) : (
            <>
                {showLegacyHead &&
                    (isDesktop ? (
                        <div className="admin-detail-head px-0 mb-0">
                            <Head onBack={this.handleGoBack} />
                            <Head
                                rightContent={this.rightContent}
                                centerElement={this.centerContentMobile}
                                hasInlineButtons
                            />
                        </div>
                    ) : (
                        <div className="admin-detail-head px-0 mb-0">
                            <Head
                                onBack={this.handleGoBack}
                                headerClassName="blue-main-header-mobile blue-main-title-mobile"
                                centerElement={this.centerContentMobile}
                                rightContent={this.rightContent}
                            />
                            {paymentAFIP.isPending && (
                                <p className="ml-3 mb-0">
                                    {isUxPaymentsServicesImprovementsEnabled() ? (
                                        <Hint
                                            colorText="dark"
                                            colorIcon="dark"
                                            text={i18n.get("pay.paymentAFIP.signPending")}
                                        />
                                    ) : (
                                        <InfoTag
                                            type="info"
                                            message={i18n.get(`payments.serviceAFIP.detail.status.PENDING`)}
                                            tagBackground="#FFE5B6"
                                            tagClass="px-2"
                                            moreStyles={{
                                                color: "black",
                                            }}
                                        />
                                    )}
                                </p>
                            )}
                        </div>
                    ))}
                {uxDashboardImprovements && !isDesktop && paymentAFIP.isPending && (
                    <p className="px-3 pt-2 mb-0">
                        {isUxPaymentsServicesImprovementsEnabled() ? (
                            <Hint colorText="dark" colorIcon="dark" text={i18n.get("pay.paymentAFIP.signPending")} />
                        ) : (
                            <InfoTag
                                type="info"
                                message={i18n.get(`payments.serviceAFIP.detail.status.PENDING`)}
                                tagBackground="#FFE5B6"
                                tagClass="px-2"
                                moreStyles={{
                                    color: "black",
                                }}
                            />
                        )}
                    </p>
                )}
                {!uxDashboardImprovements && <Notification scopeToShow="paymentAFIP" />}
                <PageLoading loading={fetching}>
                    <MainContainer>
                        <div className="above-the-fold">
                            {paymentAFIP && (
                                <PaymentAFIPDetailContent paymentAFIP={paymentAFIP} isDesktop={isDesktop} />
                            )}
                        </div>
                    </MainContainer>
                </PageLoading>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    fetching: paymentsAFIPSelectors.getFetching(state),
    paymentAFIP: paymentsAFIPSelectors.getPaymentAFIP(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    isReturnFromDetail: paymentsAFIPSelectors.getIsReturnFromDetail(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(MultipleAFIPDetail);
